import { jsx as _jsx } from "react/jsx-runtime";
import { uploadByIdSelector } from "@air/redux-uploader";
import { memo } from "react";
import { KanbanUploadingAssetComponent } from "~/components/KanbanView/KanbanColumnsManagers/shared/KanbanColumnItems/KanbanItem/shared/KanbanUploadingAssetComponent";
import { KanbanUploadingFileComponent } from "~/components/KanbanView/KanbanColumnsManagers/shared/KanbanColumnItems/KanbanItem/shared/KanbanUploadingFileComponent";
import { useURLShortIdSelector } from "~/hooks/useURLShortIdSelector";
import { DndItemType } from "~/types/DndKit";
import { useAirStore } from "~/utils/ReduxUtils";
import { PrivateKanbanAsset } from "./PrivateKanbanAsset";
import { PrivateKanbanBoard } from "./PrivateKanbanBoard";
import { PrivateKanbanFile } from "./PrivateKanbanFile";
import { PublicKanbanAsset } from "./PublicKanbanAsset";
import { PublicKanbanBoard } from "./PublicKanbanBoard";
import { PublicKanbanFile } from "./PublicKanbanFile";
/* eslint-disable react/prop-types */ export const KanbanItem = /*#__PURE__*/ memo((param)=>{
    let { cardHeight, kanbanDndItemData, style } = param;
    const shortId = useURLShortIdSelector();
    const store = useAirStore();
    const apiItemDataObject = kanbanDndItemData.apiData.data;
    if (shortId) {
        switch(kanbanDndItemData.dndType){
            case DndItemType.kanbanAsset:
                {
                    return /*#__PURE__*/ _jsx(PublicKanbanAsset, {
                        cardHeight: cardHeight,
                        asset: apiItemDataObject,
                        kanbanDndItemData: kanbanDndItemData,
                        style: style
                    });
                }
            case DndItemType.kanbanBoard:
                {
                    return /*#__PURE__*/ _jsx(PublicKanbanBoard, {
                        board: apiItemDataObject,
                        kanbanDndItemData: kanbanDndItemData,
                        style: style
                    });
                }
            case DndItemType.kanbanFile:
                {
                    return /*#__PURE__*/ _jsx(PublicKanbanFile, {
                        cardHeight: cardHeight,
                        file: apiItemDataObject,
                        kanbanDndItemData: kanbanDndItemData,
                        style: style
                    });
                }
        }
    }
    switch(kanbanDndItemData.dndType){
        case DndItemType.kanbanAsset:
            {
                return /*#__PURE__*/ _jsx(PrivateKanbanAsset, {
                    cardHeight: cardHeight,
                    asset: apiItemDataObject,
                    kanbanDndItemData: kanbanDndItemData,
                    style: style
                });
            }
        case DndItemType.kanbanBoard:
            {
                return /*#__PURE__*/ _jsx(PrivateKanbanBoard, {
                    board: apiItemDataObject,
                    kanbanDndItemData: kanbanDndItemData,
                    style: style
                });
            }
        case DndItemType.kanbanFile:
            {
                return /*#__PURE__*/ _jsx(PrivateKanbanFile, {
                    cardHeight: cardHeight,
                    file: apiItemDataObject,
                    kanbanDndItemData: kanbanDndItemData,
                    style: style
                });
            }
        case DndItemType.kanbanUpload:
            {
                const upload = uploadByIdSelector(store.getState(), kanbanDndItemData.itemId);
                if (!upload) {
                    return null;
                }
                if (upload.isNonMedia) {
                    return /*#__PURE__*/ _jsx(KanbanUploadingFileComponent, {
                        upload: upload,
                        kanbanDndItemData: kanbanDndItemData,
                        style: style
                    });
                }
                return /*#__PURE__*/ _jsx(KanbanUploadingAssetComponent, {
                    upload: upload,
                    kanbanDndItemData: kanbanDndItemData,
                    style: style
                });
            }
    }
});
/* eslint-enable react/prop-types */ KanbanItem.displayName = "KanbanItem";
